import script from "./BindingProcess.vue?vue&type=script&setup=true&lang=js"
export * from "./BindingProcess.vue?vue&type=script&setup=true&lang=js"

import "./BindingProcess.vue?vue&type=style&index=0&id=bcd1af98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bcd1af98"]])

export default __exports__